/**
 * Utility to log errors in a consistent format
 * This can be expanded to send errors to an error tracking service
 */
export const logError = (errorType, error, errorInfo = null, metadata = {}) => {
  // Log to console in development
  if (process.env.NODE_ENV !== 'production') {
    console.group(`Error: ${errorType}`);
    console.error('Error:', error);
    if (errorInfo) {
      console.error('Component Stack:', errorInfo.componentStack);
    }
    if (Object.keys(metadata).length > 0) {
      console.info('Additional Info:', metadata);
    }
    console.groupEnd();
  }
  
  // In production, send to error tracking service
  if (process.env.NODE_ENV === 'production') {
    // Example for future integration with error tracking services
    // Replace with your actual implementation
    
    // Example structure for sending to an API:
    const errorData = {
      type: errorType,
      message: error.toString(),
      stack: error.stack,
      componentStack: errorInfo?.componentStack,
      url: window.location.href,
      userAgent: navigator.userAgent,
      timestamp: new Date().toISOString(),
      ...metadata
    };
    
    // Uncomment and implement when ready:
    // sendToErrorTrackingService(errorData);
  }
};

// Placeholder function for future implementation
// const sendToErrorTrackingService = (errorData) => {
//   // Implementation depends on your error tracking service
//   // Example: fetch('/api/log-error', {
//   //   method: 'POST',
//   //   headers: { 'Content-Type': 'application/json' },
//   //   body: JSON.stringify(errorData)
//   // }).catch(console.error);
// }; 